import * as React from "react";
const SvgDropdownUpFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 4, viewBox: "0 0 9 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.75 -3.49691e-07L8.75 4L0.75 4L4.75 -3.49691e-07Z", fill: "currentColor" }));
export default SvgDropdownUpFilled;
